// src/api/product.js or wherever your APIs are grouped
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_ADMIN_URL;

export const fetchAllProducts = async () => {
  const res = await axios.get(`${BASE_URL}/get-products`);
  return res.data;
};  

export const fetchProductBySlug = async (slug) => {
  const res = await axios.get(`${BASE_URL}/get-product/${slug}`);
  return res.data;
};